import * as React from 'react';

import { ILocalization, useLocalization } from '@shared-ui/localization-context';

import { Level, liveAnnounce } from 'uitk-react-utils';

interface AnnounceLoadingStateProps {
  isLoading?: boolean;
  isError?: boolean;
  l10n?: ILocalization;
  accessibilityLabel: string;
}

export const AnnounceLoadingState: React.FC<AnnounceLoadingStateProps> = ({ isLoading, isError, accessibilityLabel }) => {
  const l10n = useLocalization();
  const [lastLoadingStateMessage, setLastLoadingStateMessage] = React.useState('');
  const a11yLabel = accessibilityLabel ?? l10n?.formatText('hotels.searchResults.resultsUpdated.liveAnnounce');

  let message;
  if (isLoading) {
    message = l10n?.formatText('hotels.searchResults.resultsLoading.liveAnnounce');
  } else if (isError) {
    message = l10n?.formatText('hotels.searchResults.errorRetrievingResults.liveAnnounce');
  } else {
    message = a11yLabel;
  }
  if (message !== lastLoadingStateMessage) {
    liveAnnounce(message, Level.POLITE);
    setLastLoadingStateMessage(message);
  }

  return null;
};
